(function () {
  "use strict";

  var BUYERS_API_URL = "https://zd-api-gateway.iterator.in/api/buyers/";
  var BUYERS_ASSETS_UPLOAD_URL =
    "https://zd-api-gateway.iterator.in/api/assets/upload/";

  function setPanelDisabled(panel, disabled) {
    if (!panel) return;
    panel.querySelectorAll("input, select, textarea").forEach(function (el) {
      if (el.type === "radio") return;
      el.disabled = disabled;
    });
  }

  function fieldToMetadataKey(label) {
    return String(label)
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "_")
      .replace(/[^a-z0-9_+]/g, "");
  }

  function collectContactFields(formEl) {
    var fd = new FormData(formEl);
    var contact = {};
    var file = null;

    fd.forEach(function (value, key) {
      var match = key.match(/^contact\[(.+)\]$/);
      if (!match) return;
      var field = match[1];
      if (value instanceof File) {
        if (field === "attachment" && value.size > 0) file = value;
        return;
      }
      if (value === "") return;
      if (Object.prototype.hasOwnProperty.call(contact, field)) {
        if (!Array.isArray(contact[field])) contact[field] = [contact[field]];
        contact[field].push(value);
      } else {
        contact[field] = value;
      }
    });

    return { contact: contact, file: file };
  }

  function buildBuyersApiPayload(formEl) {
    var collected = collectContactFields(formEl);
    var c = collected.contact;
    var reg = c["Registration type"] || "";
    var isCompany = reg === "Company";

    var name = isCompany ? c["Business name"] || "" : c.name || "";
    var email = c.email || "";
    var phone = c.Phone || "";

    var business_type = isCompany ? "COMPANY" : "INDIVIDUAL";

    var metadata = {
      source: "website",
      country: "UK",
    };

    var exclude = {
      "Registration type": true,
      email: true,
      Phone: true,
    };

    if (isCompany) {
      exclude["Business name"] = true;
    } else {
      exclude.name = true;
    }

    Object.keys(c).forEach(function (key) {
      if (exclude[key]) return;
      var val = c[key];
      if (isCompany && key === "name") {
        metadata.primary_contact_name = val;
        return;
      }
      var mk = fieldToMetadataKey(key);
      if (mk) metadata[mk] = val;
      else metadata[key] = val;
    });

    if (collected.file) {
      metadata.id_upload = {
        filename: collected.file.name,
        size: collected.file.size,
        type: collected.file.type,
      };
    }

    return {
      name: String(name).trim(),
      email: String(email).trim(),
      phone: String(phone).trim(),
      business_type: business_type,
      metadata: metadata,
    };
  }

  function setStatus(statusEl, type, message) {
    if (!statusEl) return;
    statusEl.hidden = !message;
    statusEl.textContent = message || "";
    statusEl.classList.remove(
      "buyer-registration__status--success",
      "buyer-registration__status--error"
    );
    if (type === "success")
      statusEl.classList.add("buyer-registration__status--success");
    else if (type === "error")
      statusEl.classList.add("buyer-registration__status--error");
  }

  function showBuyerSuccess(root, formEl) {
    if (!root || !formEl) return;
    var shell = root.querySelector("[data-buyer-form-shell]");
    var successEl = root.querySelector("[data-buyer-success]");
    var statusEl = formEl.querySelector("[data-buyer-status]");
    setStatus(statusEl, null, "");
    if (statusEl) statusEl.hidden = true;
    if (shell) shell.hidden = true;
    if (successEl) {
      successEl.hidden = false;
      successEl.focus();
    }
  }

  function syncCompanyBuyerType(root, sectionId) {
    var companyRadio = document.getElementById(
      "BuyerType-company-" + sectionId
    );
    if (companyRadio) {
      companyRadio.checked = true;
      companyRadio.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function extractBuyerId(body) {
    if (!body || typeof body !== "object") return null;
    if (body.id != null) return body.id;
    if (body.buyer_id != null) return body.buyer_id;
    if (body.buyerId != null) return body.buyerId;
    if (body.data && typeof body.data === "object") {
      var d = body.data;
      if (d.id != null) return d.id;
      if (d.buyer_id != null) return d.buyer_id;
      if (d.buyerId != null) return d.buyerId;
    }
    return null;
  }

  function uploadBuyerProofOfAge(buyerId, file) {
    if (buyerId == null || buyerId === "" || !file || file.size === 0) return;
    var fd = new FormData();
    fd.append("file_type", "BUYER_PROOF_OF_AGE");
    fd.append("files", file);
    var q =
      "content_type=buyers.buyer&object_id=" +
      encodeURIComponent(String(buyerId));
    return fetch(BUYERS_ASSETS_UPLOAD_URL + "?" + q, {
      method: "POST",
      body: fd,
    });
  }

  function bindSubmit(formEl) {
    if (!formEl || formEl.dataset.buyerRegSubmitBound === "1") return;
    formEl.dataset.buyerRegSubmitBound = "1";

    formEl.addEventListener("submit", function (e) {
      e.preventDefault();

      if (!formEl.checkValidity()) {
        formEl.reportValidity();
        return;
      }

      var root = formEl.closest("[data-buyer-registration]");
      var apiUrl =
        (root && root.getAttribute("data-buyer-api-url")) || BUYERS_API_URL;
      var statusEl = formEl.querySelector("[data-buyer-status]");
      var submitBtn = formEl.querySelector('button[type="submit"]');

      var payload = buildBuyersApiPayload(formEl);

      setStatus(statusEl, null, "");
      if (statusEl) statusEl.hidden = true;

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute("aria-busy", "true");
      }

      fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          return res.text().then(function (text) {
            var body = null;
            if (text) {
              try {
                body = JSON.parse(text);
              } catch (err) {
                body = { raw: text };
              }
            }
            return { ok: res.ok, status: res.status, body: body };
          });
        })
        .then(function (result) {
          if (result.ok) {
            console.log(result);
            var collected = collectContactFields(formEl);
            var proofFile = collected.file;
            var buyerId = result.body.id;
            if (proofFile && buyerId != null && buyerId !== "") {
              uploadBuyerProofOfAge(buyerId, proofFile).catch(function () {});
            }
            formEl.reset();
            if (root) {
              var sid = root.getAttribute("data-section-id");
              if (sid) syncCompanyBuyerType(root, sid);
              showBuyerSuccess(root, formEl);
            }
            return;
          }

          var errMsg =
            (result.body &&
              (result.body.detail ||
                result.body.message ||
                result.body.error)) ||
            "Something went wrong. Please try again.";
          if (typeof errMsg === "object") errMsg = JSON.stringify(errMsg);
          setStatus(statusEl, "error", errMsg + " (" + result.status + ")");
        })
        .catch(function () {
          setStatus(
            statusEl,
            "error",
            "Could not reach the server. Check your connection or try again later."
          );
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute("aria-busy");
          }
        });
    });
  }

  function initRoot(root) {
    var sectionId = root.getAttribute("data-section-id");
    if (!sectionId) return;

    var companyPanel = document.getElementById(
      "buyer-registration-business-" + sectionId
    );
    var individualPanel = document.getElementById(
      "buyer-registration-individual-" + sectionId
    );
    var radios = root.querySelectorAll(".buyer-registration__type-radio");
    var companyType = document.getElementById("BusinessType-" + sectionId);
    var companiesWrap = document.getElementById(
      "CompaniesHouseWrap-" + sectionId
    );
    var companiesInput = document.getElementById("CompaniesHouse-" + sectionId);
    var formEl = document.getElementById("BuyerRegistrationForm-" + sectionId);

    function updateCompanyType() {
      if (!companyType || !companiesWrap || !companiesInput) return;
      var isCompany = document.getElementById(
        "BuyerType-company-" + sectionId
      ).checked;
      if (!isCompany) return;
      var v = companyType.value;
      var needCh = v === "Ltd" || v === "LLP";
      companiesWrap.hidden = !needCh;
      companiesInput.required = needCh;
      companiesInput.disabled = !needCh;
      if (!needCh) {
        companiesInput.value = "";
      }
    }

    function updateBuyerType() {
      var isCompany = document.getElementById(
        "BuyerType-company-" + sectionId
      ).checked;
      if (companyPanel) companyPanel.hidden = !isCompany;
      if (individualPanel) individualPanel.hidden = isCompany;
      setPanelDisabled(companyPanel, !isCompany);
      setPanelDisabled(individualPanel, isCompany);
      updateCompanyType();
    }

    radios.forEach(function (r) {
      r.addEventListener("change", updateBuyerType);
    });
    if (companyType) {
      companyType.addEventListener("change", updateCompanyType);
    }
    updateBuyerType();

    bindSubmit(formEl);
  }

  function initAll() {
    document.querySelectorAll("[data-buyer-registration]").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-buyer-registration]");
    if (root) initRoot(root);
  });
})();
